import { useAuth } from '@/contexts/AuthContext';
import { useRolesAdicionales } from '@/hooks/useRolesAdicionales';

const ROLE_EMBAJADOR_ID = 25;

/** Rol 25 Embajador como principal o como adicional en `user_roles`. null mientras consulta. */
export function useHasEmbajadorRole(): boolean | null {
  const { profile } = useAuth();
  const { roles } = useRolesAdicionales();

  if (!profile?.email) return false;
  if (profile.rol_id === ROLE_EMBAJADOR_ID) return true;
  return roles === null ? null : roles.includes(ROLE_EMBAJADOR_ID);
}
